export function stripLocaleFromUrl(url, locale) {
  var includePrefixSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!locale) {
    return url;
  }
  return url.replace(new RegExp("".concat(includePrefixSeparator ? '/' : '').concat(locale, "(\\/|\\?|$)")), '$1');
}